import React from 'react'
import { useHistory } from 'react-router-dom'
import Button from '../../../components/Button'
import Icon from '../../../components/Icon'
import Private from '../../../components/Private'
import Text from '../../../components/Text'
import routes from '../../../config/routes'
import ChangePasswordForm from '../../../forms/ChangePassword'
import { Container } from '../styles'

interface Props {

}

const ChangePasswordScreen: React.FC<Props> = () => {
  const history = useHistory()

  return (
    <Private>
      <Container>
        <Text
          tag="h1"
        >
          <Button
            label={(
              <Icon
                name="close"
              />
            )}
            smallPadding
            backgroundColor="transparent"
            onClick={() => history.push(routes.settings.security.index.path)}
          />
          {' '}Alterar Senha
          </Text>

        <ChangePasswordForm
          onSubmit={() => history.push(routes.settings.security.index.path)}
        />
      </Container>
    </Private>
  )
}

export default ChangePasswordScreen
